import React from 'react'

const generateArray = (from, to) => {
    var array = []
    if (from <= to)
        for (var i = from; i <= to; i++)
            array.push(i)
    else
        for (var j = from; j >= to; j--)
            array.push(j)

    return array

}
const days = generateArray(1, 31)
const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"]
const years = (from, to) => generateArray(from, to)

export const MIN_YEAR = 1950
var d= new Date()
export const MAX_YEAR = ((d.getMonth()==11)? d.getFullYear() +2:d.getFullYear()+1)

export const getDayOptions = days.map(day => <option key={day} value={day}>{day}</option>)
export const getMonthOptions = months.map((month, i) => <option key={i + 1} value={i + 1}>{month}</option>)
export const getYearOptions = (from = MAX_YEAR, to = MIN_YEAR) => years(from, to).map(year => <option key={year} value={year}>{year}</option>)
export const getYearOptionsPlus = (from = MAX_YEAR + 5, to = MIN_YEAR) => years(from, to).map(year => <option key={year} value={year}>{year}</option>)


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/services/dateServices.js